var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "section" }, [
        _c("div", { staticStyle: { width: "80%", "min-width": "1000px" } }, [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclarationInfo")))
          ]),
          _c(
            "div",
            {
              staticClass: "form-row",
              staticStyle: { display: "flex", "flex-direction": "row" }
            },
            [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      flex: "1",
                      "flex-direction": "column",
                      "margin-right": "10px"
                    }
                  },
                  [
                    !_vm.isSalesForSzfs
                      ? _c(
                          "el-form",
                          {
                            attrs: {
                              disabled: _vm.readonly,
                              "label-width": "90px",
                              "label-position": "left"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "custom",
                                attrs: {
                                  label: _vm.$t("SeaExport.CustomsBroker")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    no: "1",
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Company,
                                    "data-filter-function":
                                      _vm.customsBrokerFilter,
                                    filterable: "",
                                    "default-value":
                                      _vm.job.customsBroker || "",
                                    "method-params": {
                                      customsBroker: true,
                                      companyLob: "airExport",
                                      active: true
                                    }
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.job.customsBroker = p.value || 0
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          "label-width": "90px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.Remarks") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: { no: "2", type: "textarea", rows: 5 },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.Remarks"),
                                    _vm.job.customsRemarks,
                                    function(val) {
                                      _vm.job.customsRemarks = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.customsRemarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "customsRemarks", $$v)
                                },
                                expression: "job.customsRemarks"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { flex: "1", "margin-left": "10px" } },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          "label-width": "90px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.AdvancePayment") }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                attrs: { no: "advancePayment" },
                                on: { change: _vm.handleAdvancePaymentChange },
                                model: {
                                  value: _vm.advancePaymentValue,
                                  callback: function($$v) {
                                    _vm.advancePaymentValue = $$v
                                  },
                                  expression: "advancePaymentValue"
                                }
                              },
                              _vm._l(
                                _vm.SystemConstants.YESORNO_STATES,
                                function(item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label:
                                        _vm.$store.getters.language === "zh"
                                          ? item.chineseName
                                          : item.englishName,
                                      value: item.code
                                    }
                                  })
                                }
                              ),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          "label-width": "90px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: _vm.$t("SeaExport.TaxRemarks") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                no: "taxRemarks",
                                type: "textarea",
                                rows: 5
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.TaxRemarks"),
                                    _vm.job.taxRemarks,
                                    function(val) {
                                      _vm.job.taxRemarks = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.taxRemarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "taxRemarks", $$v)
                                },
                                expression: "job.taxRemarks"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { flex: "1", "margin-left": "10px" } },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: { disabled: _vm.readonly, "label-width": "90px" }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.CustomsDutyAmount")
                            }
                          },
                          [
                            _c("auto-number-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                no: "customsDutyAmount",
                                precision: 2,
                                disabled: _vm.readonly,
                                min: 0
                              },
                              model: {
                                value: _vm.job.customsDutyAmount,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "customsDutyAmount", $$v)
                                },
                                expression: "job.customsDutyAmount"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { flex: "1", "margin-left": "10px" } },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: { disabled: _vm.readonly, "label-width": "90px" }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.VatAmount") } },
                          [
                            _c("auto-number-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                no: "vatAmount",
                                precision: 2,
                                disabled: _vm.readonly,
                                min: 0
                              },
                              model: {
                                value: _vm.job.vatAmount,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "vatAmount", $$v)
                                },
                                expression: "job.vatAmount"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { flex: "1", "margin-left": "10px" } },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: { disabled: _vm.readonly, "label-width": "90px" }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.PaymentTime") } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                no: "paymentTime",
                                disabled: _vm.readonly,
                                type: "date",
                                clearable: "",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.job.paymentTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "paymentTime", $$v)
                                },
                                expression: "job.paymentTime"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ])
      ]),
      _c("div", { staticClass: "section" }, [
        _c("div", { staticStyle: { width: "80%", "min-width": "1000px" } }, [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.OnwardInfo")))
          ]),
          _c(
            "div",
            {
              staticClass: "form-row",
              staticStyle: { display: "flex", "flex-direction": "row" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": _vm.$selectByLang("90px", "110px"),
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("SeaExport.TheActualFlight") + "："
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: { no: "3" },
                            model: {
                              value: _vm.job.actualFlight,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "actualFlight", $$v)
                              },
                              expression: "job.actualFlight"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "custom", attrs: { label: "ATD：" } },
                        [
                          _c("el-date-picker", {
                            ref: "secondAtd",
                            staticStyle: { width: "300px" },
                            attrs: {
                              no: "4",
                              type: "date",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "secondAtd",
                                  null,
                                  true,
                                  false,
                                  _vm.job
                                )
                              }
                            },
                            model: {
                              value: _vm.job.secondAtd,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "secondAtd", $$v)
                              },
                              expression: "job.secondAtd"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": _vm.$selectByLang("90px", "110px"),
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("SeaExport.OnwardInfo") + "："
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: { no: "5", type: "textarea", rows: 5 },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.OnwardInfo"),
                                  _vm.job.onwardJourney,
                                  function(val) {
                                    _vm.job.onwardJourney = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.onwardJourney,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "onwardJourney", $$v)
                              },
                              expression: "job.onwardJourney"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ])
      ]),
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c(
              "cargo-button-group-slider",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "6",
                      type: "primary",
                      disabled: !_vm.btnEnable
                    },
                    on: { click: _vm.addCustInfoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.NewCustomsDeclaration")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "7",
                      type: "primary",
                      disabled: !_vm.btnEnable
                    },
                    on: { click: _vm.editCustInfoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.EditCustomsDeclaration")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "8",
                      type: "danger",
                      disabled: !_vm.btnEnable
                    },
                    on: { click: _vm.delCustInfoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteCustomsDeclaration")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.closeXhqCustoms &&
                          !_vm.openOujianCustoms &&
                          _vm.job.lob === "AE" &&
                          !_vm.openMeiHuaCustom,
                        expression:
                          "closeXhqCustoms && !openOujianCustoms && job.lob === 'AE' && !openMeiHuaCustom"
                      }
                    ],
                    attrs: {
                      no: "GetOcrFile",
                      type: "primary",
                      disabled:
                        _vm.job.jobState !== 0 ||
                        _vm.isEdit ||
                        !_vm.$checkPermission([
                          "button_customs_IdentifyTheCustoms"
                        ])
                    },
                    on: { click: _vm.getOcrFileHandler }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("CargoMsg.Cargo_IdentifyTheCustomsDeclaration")
                      )
                    )
                  ]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.closeXhqCustoms &&
                          !_vm.openOujianCustoms &&
                          _vm.job.lob === "AE" &&
                          !_vm.openMeiHuaCustom,
                        expression:
                          "closeXhqCustoms && !openOujianCustoms && job.lob === 'AE' && !openMeiHuaCustom"
                      }
                    ],
                    attrs: {
                      no: "RefreshOcrFile",
                      type: "primary",
                      disabled: _vm.job.jobState !== 0 || _vm.isEdit
                    },
                    on: { click: _vm.loadList }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_RefreshCustomsDeclaration"))
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticStyle: { height: "100%", "margin-top": "5px" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "config-module": !_vm.openMeiHuaCustom ? "1900003" : "1900005",
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.gridParams,
              "column-defs": !_vm.openMeiHuaCustom
                ? _vm.columnDefs
                : _vm.xhqColumnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c("customs-info-dialog", {
        ref: "customsInfoDialog",
        attrs: {
          visible: _vm.editDialog.visible,
          "is-sales-for-szfs": _vm.isSalesForSzfs,
          "selected-customs-info": _vm.selectedCustomsInfo,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          successHandler: _vm.successHandler
        }
      }),
      _c("customs-info-dialog-ouj", {
        ref: "customsInfoDialogOuj",
        attrs: {
          visible: _vm.editOujianDialog.visible,
          "selected-customs-info": _vm.editOujianDialog.customsInfo,
          job: _vm.editOujianDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editOujianDialog, "visible", $event)
          },
          successHandler: _vm.successHandler,
          close: function($event) {
            _vm.editOujianDialog.visible = false
          }
        }
      }),
      _c("customs-info-interact-res-dialog", {
        ref: "customsInfoInteractResDialog",
        attrs: {
          visible: _vm.interactResDialog.visible,
          "customs-id": _vm.interactResDialog.customsId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.interactResDialog, "visible", $event)
          }
        }
      }),
      _c("file-history-dialog", {
        ref: "fileHistoryDialog",
        attrs: {
          visible: _vm.fileHistoryDialog.visible,
          "customs-id": _vm.fileHistoryDialog.customsId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fileHistoryDialog, "visible", $event)
          }
        }
      }),
      _c("customs-info-res-file-history-dialog", {
        attrs: {
          visible: _vm.customsInfoFileDialog.visible,
          "customs-info": _vm.customsInfoFileDialog.customsInfo,
          "customs-info-key": _vm.customsInfoFileDialog.customsInfoKey
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.customsInfoFileDialog, "visible", $event)
          }
        }
      }),
      _c("customs-receipt-record-dialog", {
        ref: "customsReceiptRecordDialog",
        attrs: {
          visible: _vm.customsReceiptRecordDialog.visible,
          "selected-customs-info": _vm.customsReceiptRecordDialog.customsInfo
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.customsReceiptRecordDialog, "visible", $event)
          }
        }
      }),
      _c("information-comparison-dialog", {
        ref: "informationComparisonDialog",
        attrs: {
          visible: _vm.informationComparisonDialog.visible,
          data: _vm.informationComparisonDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.informationComparisonDialog, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceText",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "warning-count": -1,
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.closeXhqCustoms && !_vm.openOujianCustoms && _vm.job.lob === "AE"
        ? _c("drop-uploader", {
            ref: "dropUploader",
            attrs: {
              action: _vm.URL.AIdiscern.importAndAnalyseFile,
              "upload-params": {
                source: _vm.INTELLIGENT_DOCUMENT_SOURCE_10.code,
                iChannel: 3,
                jobUuid: _vm.job.uuid,
                pageSource: "customsInfo",
                officeId: _vm.$store.getters.currentOfficeId
              },
              accept: [
                "pdf",
                "xls",
                "xlsx",
                "doc",
                "docx",
                "jpg",
                "gif",
                "png",
                "tif",
                "msword",
                "ms-excel",
                "jpeg",
                "rtf"
              ],
              "file-format": _vm.fileFormat,
              multiple: false,
              "open-drag": false,
              "bs-open": _vm.bsOpen
            },
            on: { "upload-result": _vm.uploadResultHandler }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }